#import "../fragments/ai-stat-fragment.graphql"

fragment AiFeatureFragment on AiFeature {
    type
    displayName
    requiresUpgrade
    minimumPlanName
    ... on AiFeatureWithStats {
        stats {
            ...AiStatFragment
        }
    }
}
